<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("regbigtitle") }}</span>
      </div>
      <!-- <div class="text">There is currently no content</div> -->
      <!-- <div class="text">
        To register for IDS 2024, please click the Register button below to
        begin registration process.
      </div>
      <div class="text">
        Please click on the Login button below to finish incomplete payment,
        download receipt/invoice, and check account status.
      </div>
      <div class="btns">
        <div @click="toReg" class="btn btn-reg">register</div>
        <div @click="toLogin" class="btn btn-login">login</div>
      </div> -->
      <div class="text">
        <div class="small-title sb-title">{{ $t("regtitle1") }}</div>

        {{ $t("regtext11") }}
        <div class="btn cup btn-reg" @click="toReg">
          {{ $t("regtext11a") }}
        </div>
        <br />
        {{ $t("regtext12") }}
        <span class="text-blue">ids2024@jiangnan.edu.cn</span>
        {{ $t("regtext12a") }}
      </div>
      <div class="reg-table">
        <el-table
          stripe
          :data="$t('regtableData')"
          border
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column prop="one" :label="$t('regCategory')">
            <template slot-scope="scoped">
              <b class="text-333">{{ scoped.row.one }}</b>
            </template>
          </el-table-column>
          <el-table-column
            prop="two"
            :render-header="twoheader"
            :label="$t('regpayabout1')"
          >
          </el-table-column>
          <el-table-column
            prop="three"
            :render-header="twoheader"
            :label="$t('regpayabout2')"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="text">{{ $t("regtext26a") }}</div>
      <div class="d-flex mt-50">
        <div class="w-50">
          <div class="small-title">
            {{ $t("regtext21a") }}
          </div>
          <div class="text pb-10">{{ $t("regtext22a") }}</div>
          <div class="text pb-10">
            {{ $t("regtext23a") }}
          </div>
          <div class="text pb-10">{{ $t("regtext24a") }}</div>
          <div class="text pb-0">{{ $t("regtext25a") }}</div>
        </div>
        <div class="w-50">
          <div class="small-title">
            {{ $t("regtext21b") }}
          </div>
          <div class="text pb-10">{{ $t("regtext22b") }}</div>
          <div class="text pb-10">
            {{ $t("regtext23b") }}
          </div>
          <div class="text pb-0">{{ $t("regtext24b") }}</div>
        </div>
      </div>
      <div class="small-title sb-title mt-50">{{ $t("regtitle2") }}</div>
      <div class="text">
        {{ $t("regtext31") }}
      </div>
      <!-- <div class="small-title mt-50">Payment Receipt Information:</div>
      <div class="text">1.</div>
      <div class="text">
        2. Please email Payment Order ID & Payment Email to
        ids2024@jiangnan.edu.cn and wait for the secretary’s confirmation.
      </div> -->
      <div class="text">
        {{ $t("regtext33") }}
        <br />
        {{ $t("regtext34") }}
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  data() {
    return {
      tableData: [
        {
          one: "Delegate",
          two: "USD 450",
          three: "USD 500",
        },
        {
          one: "Student",
          two: "USD 220",
          three: "USD 250",
        },
        {
          one: "Accompanying person",
          two: "USD 150",
          three: "USD 150",
        },
      ],
    };
  },
  mounted() {
    console.log(window.localStorage.getItem("language"));
  },
  methods: {
    twoheader(h, { column, $index }) {
      return h("div", {}, [
        h("div", {}, column.label.split("aaa")[0]),
        h("div", {}, column.label.split("aaa")[1]),
      ]);
    },
    toReg() {
      // this.$router.push("/register");
      this.$message.error("Under Construction");
    },
    toLogin() {
      let aa = localStorage.getItem("ifcn");
      if (aa == 1) {
        this.$router.push("/loginzh");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>
    
<style scoped>
.sb-title {
  color: #0270c0 !important;
}

.mt-50 {
  margin-top: 50px;
}

.d-flex {
  display: flex;
  justify-content: space-between;
}

.w-50 {
  width: calc(50% - 30px);
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.pb-10 {
  padding-bottom: 10px !important;
  line-height: 1.4 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.btns {
  display: flex;
  margin-bottom: 20px;
}

.btn {
  margin-right: 20px;
  padding: 0 20px;
  background: #0a9a7a;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
}

.btn-reg {
  cursor: no-drop;
  background: #999;
}

.btn-login {
  background-color: rgb(55, 122, 245);
}

.text-blue {
  color: rgb(55, 122, 245);
}

.mt-30 {
  margin-top: 30px;
}

.email {
  cursor: pointer;
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  box-sizing: border-box;
  color: #333;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.text-333 {
  color: #333 !important;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .d-flex {
    display: block;
  }

  .w-50 {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reg.vue